import { IconButton } from '@mui/material';
import { useIntl } from 'react-intl';

import Icon from 'components/@icons/Icon';

interface Props {
  onClose?: () => void;
  onBack?: () => void;
}

const DrawerActions = ({ onClose, onBack }: Props) => {
  const intl = useIntl();

  return (
    <>
      {onClose && (
        <IconButton
          size="small"
          variant="filled"
          onClick={onClose}
          aria-label={intl.formatMessage({ id: 'navigation.close' })}
          sx={{
            position: 'absolute',
            right: { xs: 16, md: 24 },
            top: 16,
            zIndex: 1,
          }}
        >
          <Icon name="Close" fontSize={24} />
        </IconButton>
      )}
      {onBack && (
        <IconButton
          size="small"
          variant="filled"
          onClick={onBack}
          aria-label={intl.formatMessage({ id: 'navigation.back' })}
          sx={{
            position: 'absolute',
            top: 16,
            left: { xs: 16, md: 24 },
            zIndex: 1,
          }}
        >
          <Icon name="ArrowLeft" rotateInArabic fontSize={24} />
        </IconButton>
      )}
    </>
  );
};

export default DrawerActions;
